import React from 'react';
import * as DateUtils from 'utils/dates';
import ActionsBlock from './ActionBlock';
import * as CurrencyUtils from 'utils/currency';

const CONFIGURATION = {};

export default CONFIGURATION;

/*
reimburse_info_msid_id 
, reimbursement_reference
, vat_return_reference 
, vat_return_version_id
, vat_amount_to_be_reimbursed
, applicant_payment_id
, iban
, bic
, vat_amount_reimbursed
, date_reimbursed
, created_by
, created_at
, modified_by
, modified_at
*/
export const TableColumns = [
  {
    label: '#',
    id: 'reimburse_info_msid_id',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Reimbursement Reference',
    id: 'reimbursement_reference',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'VAT Return Reference',
    id: 'vat_return_reference',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'VAT Return Version ID',
  //   id: 'vat_return_version_id',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'To Reimburse',
    id: 'vat_amount_to_be_reimbursed',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            color: data[rowIndex].vat_amount_reimbursed ? 'black' : 'red',
            fontWeight: data[rowIndex].vat_amount_reimbursed
              ? 'normal'
              : 'bold',
          }}
        >
          €{CurrencyUtils.formatCurrency(cellValue)}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  // {
  //   label: 'Applicant Payment ID',
  //   id: 'applicant_payment_id',
  //   render: (rowIndex: number, cellValue: any, columnIndex: number) => (
  //     <React.Fragment>{cellValue}</React.Fragment>
  //   ),
  //   inData: true,
  // },
  {
    label: 'Reimbursed',
    id: 'vat_amount_reimbursed',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: Array<any>
    ) => (
      <React.Fragment>
        <span
          style={{
            color: data[rowIndex].vat_amount_reimbursed ? 'black' : 'red',
            fontWeight: data[rowIndex].vat_amount_reimbursed
              ? 'normal'
              : 'bold',
          }}
        >
          {cellValue ? `€${CurrencyUtils.formatCurrency(cellValue)}` : '€0.00'}
        </span>
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Date',
    id: 'date_reimbursed',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        {cellValue ? DateUtils.formatDate(cellValue) : 'Pending'}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'IBAN',
    id: 'iban',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue ? cellValue : 'Pending'}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'BIC Code',
    id: 'bic',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue ? cellValue : 'Pending'}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Actions',
    align: 'center',
    id: 'action1',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: any
    ) => (
      <ActionsBlock
        reimburse_info_msid_id={data[rowIndex].reimburse_info_msid_id}
        iban={data[rowIndex].iban}
        bic={data[rowIndex].bic}
        vat_amount_to_be_reimbursed={data[rowIndex].vat_amount_to_be_reimbursed}
        date_reimbursed={data[rowIndex].date_reimbursed}
        status={data[rowIndex].date_reimbursed ? 1 : 0}
      />
    ),
    inData: false,
  },
];

interface ITableDefaultFetchValues {
  TABLE_DEFAULT_PAGE: number;
  TABLE_DEFAULT_PAGE_SIZE: number;
  TABLE_DEFAULT_ORDER: 'desc' | 'asc';
  TABLE_DEFAULT_SORT_KEY: string;
}

export const ReimbursementsTableDefaultFetchValues: ITableDefaultFetchValues = {
  TABLE_DEFAULT_PAGE: 0,
  TABLE_DEFAULT_PAGE_SIZE: 25,
  TABLE_DEFAULT_ORDER: 'desc',
  TABLE_DEFAULT_SORT_KEY: TableColumns[0].id,
};
